import React, { useState, useEffect, useRef, useCallback } from 'react';
import Select from 'react-select';
import axios from "axios";
import Header from '../Header';
import Footer from '../Footer';
import FlashMessage from '../FlashMessage';
import CustomDateRangePicker from '../common/CustomDateRangePicker';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { API_URL, BASE_URL } from '../Config';
import config from "../common/Config";
import AccountService from '../../services/AccountServices';
import Swal from 'sweetalert2';
import jsPDF from "jspdf";
import "jspdf-autotable";
import InvoicePaymentAllocation from './InvoicePaymentAllocation'; // adjust path if needed

const CustomerAccounts = () => {

	const [dates, setDates] = useState([null, null]);
	const [reportrange, setReportrange] = useState('');

	const [customerOptions, setCustomerOptions] = useState([]);
	const [customerInputValue, setCustomerInputValue] = useState('');
	const accessToken = localStorage.getItem('accessToken');
	const user_id = localStorage.getItem('userId');



	const [flashMessage, setFlashMessage] = useState(null);

	const [customerLedger, setCustomerLedger] = useState([]);


	const [customer, setCustomer] = useState({
		name: '',
		accound_no: '',
		route_name: '',
	});
	const [nodataRow, setNodataRow] = useState('');

	const [debtProfile, setDebtProfile] = useState({
		zeroto30Due: '0.00',
		moreThan30DaysDue: 0,
		moreThan60DaysDue: 0,
		moreThan90DaysDue: 0,
		current_outstanding: 0,
		total_due1: 0,
		unallocated_amount: 0,
	});
	const [showModal, setShowModal] = useState(false);
	const modalRef = useRef(null);

	const [shopDetails, setShopDetails] = useState(null);
	const [logoBase64, setLogoBase64] = useState(null);

	const [activeTab, setActiveTab] = useState('ordered'); // Add tab state

	// Helper to fetch image as base64
	const fetchImageAsBase64 = async (url) => {
		try {
			const response = await fetch(url);
			const blob = await response.blob();
			return await new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onloadend = () => resolve(reader.result);
				reader.onerror = reject;
				reader.readAsDataURL(blob);
			});
		} catch {
			return null;
		}
	};

	// Fetch logo as base64 when shopDetails.logo changes
	useEffect(() => {
		if (shopDetails && shopDetails.logo) {
			fetchImageAsBase64(shopDetails.logo).then(setLogoBase64);
		}
	}, [shopDetails]);

	const handleCloseMessage = () => {
		setFlashMessage(null);
	};

	const formatNumber = (num) => {
		return parseFloat(num).toFixed(2);
	};

	const searchFormData = () => {
		let startDate = dates[0] ? format(dates[0], 'MM/dd/yyyy') : '';
		let endDate = dates[1] ? format(dates[1], 'MM/dd/yyyy') : '';
		setReportrange(startDate ? startDate + ' - ' + endDate : '');
		//setShouldLoadPayments(true); 
		let customerId = customerInputValue ? customerInputValue.value : '';
		// console.log(customerInputValue ? customerInputValue.value : '');

		if (!customerId) {
			setFlashMessage({ message: 'Please select customer', type: 'error' });
			return;
		}
		loadCustomerLadger(customerId, startDate, endDate);



	};

	const loadCustomerLadger = async (customerId, startDate, endDate) => {
		try {
			const data = await AccountService.fetchCustomerLadger(customerId, startDate, endDate, accessToken);
			//console.log(data);
			if (Array.isArray(data) && data.length === 0) {
				console.log('No data available.');
				setCustomer({ name: '', accound_no: '', route_name: '' });
				setDebtProfile({
					zeroto30Due: 0,
					moreThan30DaysDue: 0,
					moreThan60DaysDue: 0,
					moreThan90DaysDue: 0,
					current_outstanding: 0,
					total_due1: 0,
					unallocated_amount: 0,
				});
				setCustomerLedger([]);
				setNodataRow('showinfo');
				return;
			}

			if (data.customer) {
				setCustomer({
					name: data.customer.name,
					accound_no: data.customer.accound_no,
					route_name: data.customer.route_name,
				});
				setDebtProfile({
					zeroto30Due: data.debtProfile.zeroto30Due,
					moreThan30DaysDue: data.debtProfile.moreThan30DaysDue,
					moreThan60DaysDue: data.debtProfile.moreThan60DaysDue,
					moreThan90DaysDue: data.debtProfile.moreThan90DaysDue,
					current_outstanding: data.debtProfile.current_outstanding,
					total_due1: data.debtProfile.total_due1,
					unallocated_amount: data.allocation_amout[0].total,
				});
				setCustomerLedger(data.customer_ledger);
				setNodataRow('');
				// Save shop details if present
				if (data.shop_details) {
					setShopDetails(data.shop_details);
					// logoBase64 will be set by useEffect above
				}
			}
		} catch (error) {
			console.log('Failed to load customer ledger', error);
		}
	}

	const fetchCustomerNameOptions = async (inputValue) => {
		if (inputValue.length < 3) {
			return;
		}

		const formData = new FormData();
		formData.append('pattern', inputValue);
		formData.append('platform', 'web');
		formData.append('authorization', accessToken);

		const apiSalesRapUrl = `${config.API_URL}/ws-get-customer-list`;
		try {
			const response = await fetch(apiSalesRapUrl, {
				method: 'POST',
				headers: {

				},
				body: formData,
			});

			const data = await response.json();
			const formattedOptions = Array.isArray(data.customer_details)
				? data.customer_details.map(item => ({
					label: item.name,
					value: item.id,
				}))
				: [];

			setCustomerOptions(formattedOptions);


		} catch (error) {
			console.error('Error fetching customer options:', error);
		}
	};
	const handleInputChange = (inputValue) => {
		fetchCustomerNameOptions(inputValue);
	};
	const handleChange = (selectedOption) => {
		setCustomerInputValue(selectedOption);

		if (!selectedOption) {
			// Clear the table and reset related states when the selection is cleared
			setCustomer({ name: '', accound_no: '', route_name: '' });
			setDebtProfile({
				zeroto30Due: '0.00',
				moreThan30DaysDue: 0,
				moreThan60DaysDue: 0,
				moreThan90DaysDue: 0,
				current_outstanding: 0,
				total_due1: 0,
				unallocated_amount: 0,
			});
			setCustomerLedger([]);
			setNodataRow('');
		}
	};

	useEffect(() => {
		if (accessToken === null) {
			window.location.href = BASE_URL;
			return;
		}

		document.title = "Customer Account";
		return () => {
			document.title = "Ebusso";
		};
	}, []);

	const handleShow = () => {
		if (modalRef.current) {
			const modal = new window.bootstrap.Modal(modalRef.current);
			modal.show();
		}
	};

	const [payDate, setPayDate] = useState(new Date().toISOString().split('T')[0]);
	const [paymentType, setPaymentType] = useState('');
	const [chequeNo, setChequeNo] = useState('');
	const [payAmount, setPayAmount] = useState('');
	const [reference, setReference] = useState('');
	const [isChequeVisible, setChequeVisible] = useState(false);

	const handlePaymentTypeChange = (e) => {
		const selectedType = e.target.value;
		setPaymentType(selectedType);
		setChequeVisible(selectedType === 'Cheque');
	};



	const handleCustomerPaymentSubmit = async (event) => {
		event.preventDefault();

		let startDate = dates[0] ? format(dates[0], 'MM/dd/yyyy') : '';
		let endDate = dates[1] ? format(dates[1], 'MM/dd/yyyy') : '';

		const formData = new FormData();
		formData.append('user_id', user_id);
		formData.append('customer_id', customerInputValue.value);
		formData.append('date', payDate);
		formData.append('amount', payAmount);
		formData.append('paid_by', paymentType);
		formData.append('reference_no', reference);
		formData.append('cheque_no', chequeNo);

		const apiBrandUrl = `${config.API_URL}/payments/add_payment`;
		try {
			const response = await fetch(apiBrandUrl, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				body: formData,
			});

			if (!response.ok) {
				throw new Error('Failed to add payment');
			}

			const data = await response.json();
			console.log(data);

			const msg = data.message;



			if (data.success) {


				Swal.fire({
					title: "Success!",
					text: "Payment added successfully.",
					icon: "success",
					timer: 2500,
					showConfirmButton: false,
				}).then(() => {



					// Reset the form state
					setPayDate('');
					setPaymentType('');
					setChequeNo('');
					setPayAmount('');
					setReference('');
					setChequeVisible(false);
					setCustomer({
						name: '',
						accound_no: '',
						route_name: '',
					});
					setCustomerLedger([]);

					// Reload the customer ledger data
					loadCustomerLadger(customerInputValue?.value, startDate, endDate);
				});


			} else {
				Swal.fire({
					title: "Failed!",
					text: msg,
					icon: "error",
					timer: 2500,
					showConfirmButton: false,
				});
			}

		} catch (error) {
			console.error('Error adding payment:', error);
		}
	};

	// PDF Export Handler
	const handlePrintPDF = async () => {
		const doc = new jsPDF();
		const margin = 14;
		let y = 15;

		// Use custom logo URL
		const logoUrl = `${config.BASE_URL}/assets/img/${accessToken}_logo.png`;
		const logoWidth = 40;
		const logoHeight = 15;

		// Fetch logo as base64 for jsPDF
		let logoImg = logoBase64;
		if (!logoImg) {
			try {
				const response = await fetch(logoUrl);
				const blob = await response.blob();
				logoImg = await new Promise((resolve, reject) => {
					const reader = new FileReader();
					reader.onloadend = () => resolve(reader.result);
					reader.onerror = reject;
					reader.readAsDataURL(blob);
				});
			} catch {
				logoImg = null;
			}
		}

		// Draw logo
		if (logoUrl) {
			try {
				doc.addImage(logoUrl, 'PNG', margin, y, logoWidth, logoHeight);
				// Do not increment y yet, as details will be on the right
			} catch (e) {
				// If image fails, skip
			}
		}

		// Draw shop details to the right of the logo
		if (shopDetails) {
			const detailsX = margin + logoWidth + 5;
			let detailsY = y + 2;

			doc.setFontSize(13);
			doc.setFont(undefined, 'bold');
			doc.text(shopDetails.shop_name || '', detailsX, detailsY);
			detailsY += 6;

			doc.setFontSize(8);
			doc.setFont(undefined, 'normal');
			if (shopDetails.address) {
				doc.text(shopDetails.address.split(','), detailsX, detailsY);

				detailsY += 8;
			}



			let phoneEmail = [];
			if (shopDetails.phone) phoneEmail.push(`Phone No : ${shopDetails.phone}`);
			if (shopDetails.email) phoneEmail.push(`Email : ${shopDetails.email}`);
			if (phoneEmail.length > 0) {
				doc.text(phoneEmail.join(' | '), detailsX, detailsY);
				detailsY += 5;
			}
			let companyVat = [];
			if (shopDetails.company_reg_no) companyVat.push(`Company No : ${shopDetails.company_reg_no}`);
			if (shopDetails.vat_no) companyVat.push(`VAT No : ${shopDetails.vat_no}`);
			if (shopDetails.website) companyVat.push(`Website : ${shopDetails.website}`);
			if (companyVat.length > 0) {
				doc.text(companyVat.join(' | '), detailsX, detailsY);
				detailsY += 5;
			}


			// After logo/details block, move y below the logo or details, whichever is lower
			y += logoImg ? (logoHeight + 2) : (detailsY - y);
		}

		// let customerTitle = customer && customer.name ? `Customer Ledger - ${customer.name} (${customer.accound_no})` : "Customer Ledger";
		// doc.setFontSize(14);
		// doc.text(customerTitle, margin, y);
		y += 6;

		// Add summary table (the section you referenced)
		const summaryRows = [
			[
				{ content: `Customer: ${customer.name} (${customer.accound_no})`, colSpan: 2, styles: { fontStyle: 'bold' } },
				{ content: "0 to 30 Days", styles: { fontStyle: 'bold', textAlign: 'right' } },
				{ content: debtProfile.zeroto30Due }
			],
			[
				{ content: "Current Bal", styles: { fontStyle: 'bold' } },
				debtProfile.current_outstanding,
				{ content: "30 + Days", styles: { fontStyle: 'bold', textAlign: 'right' } },
				debtProfile.moreThan30DaysDue
			],
			[
				{ content: "Amount Due", styles: { fontStyle: 'bold' } },
				debtProfile.total_due1,
				{ content: "60 + Days", styles: { fontStyle: 'bold' } },
				debtProfile.moreThan60DaysDue
			],
			[
				{ content: "", styles: { fontStyle: 'bold' } },
				,
				{ content: "90 + Days", styles: { fontStyle: 'bold' } },
				debtProfile.moreThan90DaysDue
			]
		];

		doc.autoTable({
			body: summaryRows,
			startY: y,
			theme: 'grid',
			styles: {
				fontSize: 10,
				cellPadding: 2,
				lineWidth: 0.3,
				lineColor: [0, 0, 0],
			},
			columnStyles: {
				0: { cellWidth: 70 },
				1: { cellWidth: 35 },
				2: { cellWidth: 40 },
				3: { cellWidth: 35, halign: 'right' } // Right align last column (amount/balance)
			},
			didParseCell: function (data) {
				if (data.cell.raw && data.cell.raw.styles && data.cell.raw.styles.fontStyle === 'bold') {
					data.cell.styles.fontStyle = 'bold';
				}
				// Right align amount/balance columns for summary table
				if (data.column.index === 1 || data.column.index === 3) {
					data.cell.styles.halign = 'right';
				}
			}
		});

		// Ledger table
		const tableColumn = ["Date", "Inv No", "Status", "Type", "Amount", "Balance"];
		const tableRows = [];

		// Sort ledger by invoice_date (format: DD-MM-YYYY) descending
		const sortedLedger = [...customerLedger].sort((a, b) => {
			const parseDMY = (str) => {
				if (!str) return new Date(0);
				const [day, month, year] = str.split('-');
				return new Date(`${year}-${month}-${day}`);
			};
			const dateA = parseDMY(a.date);
			const dateB = parseDMY(b.date);
			return dateA - dateB;
		});

		sortedLedger.forEach((item) => {
			const {
				date,
				particulars,
				payment_status,
				payment_type,
				paid_by,
				orderId,
				amount,
				balance,
			} = item;

			let invNo = "";
			let status = "";
			let type = "";

			// Hide "Opening Balance" if accessToken is 'eve'
			if (particulars === 'Opening Balance' && accessToken === 'eve') {
				return; // Skip this row
			}

			

			if (particulars === 'Initial Balance') {
				invNo = 'Initial Balance';
			} else if (particulars === 'Opening Balance') {
				invNo = 'Opening Balance';
			} else if (payment_type === 'c') {
				type = (paid_by && paid_by !== 'NULL' && paid_by.trim() !== '' && paid_by.trim() !== '0') ? paid_by : particulars;
			} else if (payment_type === 'd') {
				invNo = orderId && orderId !== '0' ? particulars : particulars;
				status = payment_status === 'Paid' ? 'Paid' : payment_status === 'Due' ? 'UnPaid' : payment_status === 'Partial' ? 'Partial' : payment_status;
				type = 'Invoice';
			} else {
				invNo = particulars && particulars !== '_' ? particulars : '';
			}

			tableRows.push([
				date || "",
				invNo || "",
				status || "",
				type || "",
				!isNaN(parseFloat(amount)) ? parseFloat(amount).toFixed(2) : "",
				!isNaN(parseFloat(balance)) ? parseFloat(balance).toFixed(2) : "",
			]);
		});

		doc.autoTable({
			head: [tableColumn],
			body: tableRows,
			startY: doc.lastAutoTable.finalY + 5,
			styles: {
				lineWidth: 0.3,
				lineColor: [0, 0, 0], // black border
			},
			headStyles: {
				fillColor: [220, 220, 220],
				textColor: [0, 0, 0],
				lineWidth: 0.5,
				lineColor: [0, 0, 0],
			},
			//tableLineColor: [0, 0, 0],
			//tableLineWidth: 0.3,
			columnStyles: {
				0: { cellWidth: 25 },
				1: { cellWidth: 35 },
				2: { cellWidth: 20 },
				3: { cellWidth: 40 },
				4: { cellWidth: 30, halign: 'right' }, // Amount right
				5: { cellWidth: 30, halign: 'right' }, // Balance right
			}
		});
		doc.save("customer_ledger.pdf");
	};

	// --- START: AmountDueCustomerList logic and state ---
	const [salesDates, setSalesDates] = useState([null, null]);
	const salesOrderRef = useRef(null);

	const handleAmountDueSubmit = (e) => {
		e.preventDefault();

		getSalesOrderList();
	};

	const handleSendEmail = async (customerId) => {
		try {
			const apiUrl = `${config.API_URL}/send_due_email`;
			const formData = new FormData();
			formData.append("customer_id", customerId);

			const response = await fetch(apiUrl, {
				method: "POST",
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				body: formData,
			});

			const data = await response.json();
			if (data.success) {
				Swal.fire("Success", "Email sent successfully!", "success");
			} else {
				Swal.fire("Error", "Failed to send email.", "error");
			}
		} catch (error) {
			Swal.fire("Error", "Failed to send email.", "error");
		}
	};

	const getSalesOrderList = () => {
		//console.log("Fetching Amount Due Customer List with dates:", startDate, endDate);
		const $table = $(salesOrderRef.current);
		if ($.fn.DataTable.isDataTable($table)) {
			$table.DataTable().destroy();
		}

		$table.DataTable({
			processing: true,
			serverSide: true,
			ajax: {
				url: `${config.API_URL}/get_amtDueCustomer`,
				type: "POST",
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				data: function (d) {
					return $.extend({}, d, {
						draw: d.draw,
						start: d.start,
						length: d.length,

						authorization: `Bearer ${accessToken}`,
					});
				},
				dataSrc: function (json) {
					return Array.isArray(json.data) ? json.data : [];
				},
			},
			language: {
				paginate: {
					first: "First",
					last: "Last",
					next: "Next",
					previous: "Previous",
				},
				search: "Search:",
			},
			columns: [
				{
					data: null,
					title: "Sr. No.",
					orderable: false,
					render: function (data, type, row, meta) {
						return meta.row + 1 + (meta.settings._iDisplayStart || 0);
					},
				},
				{ data: "customer_name" },
				{ data: "total_due", className: "text-end", width: "10%" },
				{ data: "get_dues_zero_to_30", className: "text-end", width: "10%" },
				{ data: "get_dues_30", className: "text-end", width: "10%" },
				{ data: "get_dues_60", className: "text-end", width: "10%" },
				{ data: "get_dues_90", className: "text-end", width: "10%" },
				{
					data: null,
					title: 'Action',
					render: function (data, type, row) {
						return `
							<div style="display: flex; align-items: center; gap: 10px;">
								<div class="action-popdot">
									<a class="icon" href="#" data-bs-toggle="dropdown" aria-expanded="false">
										<i class="bi bi-three-dots"></i>
									</a>
									<ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow"> 
										<li>
											<a class="deductionbtn send-email-btn" data-customerid="${row.id}" title="Send Email">
												<i class="bi bi-envelope"></i>Send Email
											</a>
										</li>      
									</ul>
								</div>
							</div>`;
					}
				}
			],
			order: [],
			pageLength: 50,
			drawCallback: function () {
				$(".send-email-btn")
					.off("click")
					.on("click", function () {
						const customerId = $(this).data("customerid");
						handleSendEmail(customerId);
					});
			},
		});
	};

	const handleExport = async () => {
		try {
			const apiUrl = `${config.API_URL}/get_amtDueCustomer`;
			const formData = new FormData();
			formData.append('draw', 1);
			formData.append('start', 0);
			formData.append('length', 1000000);
			const [startDate, endDate] = salesDates;
			let formattedStartDate = startDate ? format(startDate, "MM/dd/yyyy") : "";
			let formattedEndDate = endDate ? format(endDate, "MM/dd/yyyy") : "";
			if (formattedStartDate) formData.append('searchByFromdate', formattedStartDate);
			if (formattedEndDate) formData.append('searchByTodate', formattedEndDate);

			const response = await fetch(apiUrl, {
				method: "POST",
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				body: formData,
			});
			const result = await response.json();
			const allData = Array.isArray(result.data) ? result.data : [];

			const wsData = [
				[
					"Sr. No.",
					"Customer Name(Ac/No)",
					"account_no",
					"Amount Due",
					"0 to 30 Days",
					"30 + Days",
					"60 + Days",
					"90 + Days"
				],
				...allData.map((row, idx) => [
					idx + 1,
					row.customer_name,
					row.account_no,
					row.total_due,
					row.get_dues_zero_to_30,
					row.get_dues_30,
					row.get_dues_60,
					row.get_dues_90
				])
			];

			const ws = window.XLSX.utils.aoa_to_sheet(wsData);
			const wb = window.XLSX.utils.book_new();
			window.XLSX.utils.book_append_sheet(wb, ws, "AmountDueCustomers");
			window.XLSX.writeFile(wb, "AmountDueCustomers.xlsx");
		} catch (err) {
			Swal.fire("Error", "Failed to export all data.", "error");
		}
	};

	useEffect(() => {
		if (accessToken === null) {
			window.location.href = `${config.BASE_URL}/login`;
			return;
		}

		getSalesOrderList();
		return () => {
			if (
				salesOrderRef.current &&
				$.fn.DataTable.isDataTable(salesOrderRef.current)
			) {
				$(salesOrderRef.current).DataTable().destroy();
			}
		};
		// eslint-disable-next-line
	}, []);
	// --- END: AmountDueCustomerList logic and state ---

	// Add state for allocation modal
	const [showAllocationModal, setShowAllocationModal] = useState(false);
	const [allocationCustomerId, setAllocationCustomerId] = useState(null);

	// Handler to open modal
	const handleOpenAllocationModal = (customerId) => {
		setAllocationCustomerId(customerId);
		setShowAllocationModal(true);
	};

	// Handler to close modal
	const handleCloseAllocationModal = () => {
		setShowAllocationModal(false);
		setAllocationCustomerId(null);
	};

	return (
		<>
			<Header />
			<div className="breadcrumbs">
				<div className="container-fluid">
					<div className="row">
						<div className="col-12 col-lg-12 col-sm-12">
							<Link to="/Dashboard"><i className="fa fa-home"></i></Link>
							<Link to="/account/customer_accounts">Account</Link>
							<span className="last-crumb">
								{activeTab === 'ordered' ? 'Customer Ledger' : 'Amount Due Customers'}
							</span>
						</div>
					</div>
				</div>
			</div>
			<div className="main-container">
				<div className="container-fluid">
					<ul className="nav nav-tabs" id="myTab" role="tablist">
						<li className="nav-item">
							<button
								className={`nav-link ${activeTab === 'ordered' ? 'active' : ''}`}
								onClick={() => setActiveTab('ordered')}
							>
								Customer Ledger
							</button>
						</li>
						<li className="nav-item">
							<button
								className={`nav-link ${activeTab === 'received' ? 'active' : ''}`}
								onClick={() => {
									if (activeTab !== 'received') {
										setActiveTab('received');
										setTimeout(() => {
											getSalesOrderList();
										}, 0);
									}
								}}
							>
								Amount Due Customers
							</button>
						</li>
					</ul>
					<div className="tab-content" id="myTabContent">
						<div
							className={`tab-pane fade ${activeTab === 'ordered' ? 'show active' : ''}`}
							id="customer-ledger"
							role="tabpanel"
						>
							{activeTab === 'ordered' && (
								<> <br />
									<p>
										{customer.name && (
											<div style={{ float: 'right', marginTop: '20px' }}>
												<button onClick={handleShow} type="button" class="acceptbtn" >Add Payment</button>
												<button onClick={handlePrintPDF} type="button" class="acceptbtn" style={{ marginRight: 10 }}>Print PDF</button>
											</div>
										)}
									</p>

									<div className="row" style={{ marginTop: '30px' }}>
										<div className="col-md-3 col-lg-3 col-sm-3" style={{ float: 'left', paddingLeft: '20px' }}>

											<Select
												isClearable
												onInputChange={handleInputChange}
												onChange={handleChange}
												options={customerOptions}
												placeholder="Search..."
												value={customerInputValue}
											/>
										</div>

										<div className="col-md-8 col-lg-8 col-sm-12">
											<CustomDateRangePicker dates={dates} onChange={setDates} onSubmit={searchFormData} />
										</div>
									</div>

									{customer.name && (
										<div className="row customerInfo" >
											<div className="col-md-7 col-lg-7 col-sm-12">
												<div className=" common-table resizable autoheight-table" id="style-3">
													<table className="table table-bordered dataTable resizable" id="pushSageList">

														<tbody style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
															<tr>
																<td style={{ width: '45%' }}><b style={{ fontWeight: '800' }}>{customer.name}({customer.accound_no})</b></td>
																<td></td>
																<td style={{ width: '30%' }}><b style={{ fontWeight: '600' }}>0 to 30 Days</b></td>
																<td className="text-end" >{debtProfile.zeroto30Due}</td>
															</tr>
															<tr>
																<td style={{ width: '45%' }}><b style={{ fontWeight: '600' }}>C. Bal</b></td>
																<td className="text-end" >{debtProfile.current_outstanding}</td>
																<td style={{ width: '30%' }}> <b style={{ fontWeight: '600' }}>30 + Days</b></td>
																<td className="text-end" >{debtProfile.moreThan30DaysDue}</td>
															</tr>
															<tr>
																<td style={{ width: '45%' }}><b style={{ fontWeight: '600' }}>Amt. Due</b></td>
																<td className="text-end" >{debtProfile.total_due1}</td>
																<td style={{ width: '30%' }}><b style={{ fontWeight: '600' }}>60 + Days</b></td>
																<td className="text-end" >{debtProfile.moreThan60DaysDue}</td>
															</tr>
															<tr>
																<td style={{ width: '45%' }}><b style={{ fontWeight: '600' }}>Unallocated Amount</b></td>
																<td className="text-end" >
																	<a
																		href="#"
																		style={{ display: 'inline-block', width: '100%' }}
																		onClick={e => {
																			e.preventDefault();
																			handleOpenAllocationModal(customerInputValue?.value);
																		}}
																	>
																		{Number(debtProfile.unallocated_amount).toFixed(2)}
																	</a>
																</td>

																<td style={{ width: '30%' }}><b style={{ fontWeight: '600' }}>90 + Days</b></td>
																<td className="text-end" >{debtProfile.moreThan90DaysDue}</td>
															</tr>
														</tbody>

													</table>
												</div>
											</div>
										</div>
									)}

									{customerLedger.length > 0 && (
										<div className="row customerInfo">
											<div className="col-md-7 col-lg-7 col-sm-12">
												<br></br>
												<div className="verical-scrl-wrapper common-table autoheight-table" id="style-3">
													<table className="table table-bordered dataTable" id="pushSageList">
														<thead>
															<tr style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
																<th >Date</th>
																<th>Inv No</th>
																<th>Status</th>
																<th>Type</th>
																<th>Amount</th>
																<th>Balance</th>

															</tr>
														</thead>
														<tbody style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
															{customerLedger.map((item, index) => {
																const {
																	id,
																	date,
																	payment_type,
																	amount,
																	balance,
																	payment_status,
																	particulars,
																	paid_by,
																	orderId
																} = item;

																const amountFormatted = !isNaN(parseFloat(amount)) ? parseFloat(amount).toFixed(2) : '';
																const balanceFormatted = !isNaN(parseFloat(balance)) ? parseFloat(balance).toFixed(2) : '';

																let rowDate = date;
																let invNo = '';
																let status = '';
																let type = '';
																let bgColor = '';
																if (particulars === 'Initial Balance') {
																	invNo = 'Initial Balance';
																	//bgColor = '#b1edb1';
																} else if (particulars === 'Opening Balance') {
																	invNo = 'Opening Balance';
																	bgColor = '#dcf2d8';
																} else if (payment_type === 'c') {
																	type = (paid_by && paid_by !== 'NULL' && paid_by.trim() !== '' && paid_by.trim() !== '0') ? paid_by : particulars;
																	bgColor = '#dcf2d8';
																} else if (payment_type === 'd') {
																	invNo = orderId && orderId !== '0'
																		? (
																			<a href={`${config.BASE_URL}/trip_summary/print/${orderId}`} target="_blank" rel="noopener noreferrer">
																				{particulars}
																			</a>
																		)
																		: particulars;
																	status = payment_status === 'Paid'
																		? 'Paid'
																		: payment_status === 'Due'
																			? 'UnPaid'
																			: payment_status === 'Partial'
																				? 'Partial'
																				: payment_status;
																	type = 'Invoice';
																} else {
																	invNo = particulars && particulars !== '_' ? particulars : '';
																}

																return (
																	<tr key={`${id}-${index}`}>
																		<td style={{ backgroundColor: bgColor }}>{rowDate}</td>
																		<td style={{ backgroundColor: bgColor }}>{invNo}</td>
																		<td style={{ backgroundColor: bgColor }}>{status}</td>
																		<td style={{ backgroundColor: bgColor }}>{type}</td>
																		<td style={{ backgroundColor: bgColor, textAlign: 'right' }}>{amountFormatted}</td>
																		<td style={{ backgroundColor: bgColor, textAlign: 'right' }}>{balanceFormatted}</td>
																	</tr>
																);
															})}
														</tbody>

													</table>
												</div>
											</div>
										</div>
									)}

									{nodataRow && (
										<div className="row text-center">
											<div className="col-md-12 col-lg-12 col-sm-12" style={{ paddingTop: '15px' }}>
												<p className="text-danger" style={{ textAlign: 'left' }}>NO Transaction Available.</p>
											</div>
										</div>
									)}

								</>
							)}
						</div>
						<div
							className={`tab-pane fade ${activeTab === 'received' ? 'show active' : ''}`}
							id="amount-due-customers"
							role="tabpanel"
						>
							{activeTab === 'received' && (
								<>
									<div className="row" style={{ marginTop: '30px' }}>

										{/* <div className="col-md-12 col-lg-6 col-sm-12" style={{ textAlign: "right", marginTop: '30px' }}>
											<button className="btn btn-success btn-sm" onClick={handleExport}>
												Export to Excel
											</button>
										</div> */}
									</div>
									<div className="" >
										<div className="col-md-12 col-lg-12 col-xs-12">
											<div
												className="verical-scrl-wrapper amount-due-customer-list-area"
												id="style-3"
											>
												<table
													className="table table-bordered dataTable resizable"
													ref={salesOrderRef}
												>
													<thead>
														<tr>
															<th>Sr. No.</th>
															<th>Customer Name(Ac/No)</th>
															<th> Amount Due </th>
															<th> 0 to 30 Days </th>
															<th>30 + Days</th>
															<th>60 + Days</th>
															<th>90 + Days</th>
															<th>Action</th>
														</tr>
													</thead>
													<tbody>
														{/* DataTable will populate this dynamically */}
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</>
							)}
						</div>
					</div>
				</div>
			</div>

			<div ref={modalRef} className="modal fade" aria-hidden="true" tabIndex="-1" role="dialog">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">Add Payment</h5>

						</div>
						<div className='add-payment-popup'>
							<form id='addCustomerForm' onSubmit={handleCustomerPaymentSubmit}>
								<div className="modal-body">

									<div className="row">
										<div className="col-md-6">
											<div className="form-group">
												<label style={{ float: 'left' }} htmlFor="date" className="col-form-label">Date: *</label>
												<input
													type="date"
													className="form-control"
													id="date"
													value={payDate}
													name="date"
													required
													onChange={(e) => setPayDate(e.target.value)}
												/>
											</div>
										</div>
										<div className="col-md-6">
											<div className="form-group">
												<label style={{ float: 'left' }} className="col-form-label" htmlFor="paid_by_1">Paying by *</label>
												<select
													name="paid_by"
													id="paid_by_1"
													className="form-select"
													required
													value={paymentType}
													onChange={handlePaymentTypeChange}
												>
													<option value="">Select Payment Type</option>
													<option value="cash">Cash</option>
													<option value="CC">Credit Card</option>
													<option value="Cheque">Cheque</option>
													<option value="Bank Transfer">Bank Transfer</option>
												</select>
											</div>
										</div>
										{isChequeVisible && (
											<div className="col-md-6">
												<div className="form-group">
													<label style={{ float: 'left' }} htmlFor="cheque_1" className="col-form-label">Cheque No: *</label>
													<input
														type="text"
														name="cheque"
														className="form-control"
														id="cheque_1"
														required
														value={chequeNo}
														onChange={(e) => setChequeNo(e.target.value)}
													/>
												</div>
											</div>
										)}
										<div className="col-md-6">
											<div className="form-group">
												<label htmlFor="amount" style={{ float: 'left' }} className="col-form-label">Amount: *</label>
												<input
													type="number"
													className="form-control no-arrows"
													id="amount"
													required
													value={payAmount}
													onChange={(e) => setPayAmount(e.target.value)}
												/>
											</div>
										</div>
										<div className="col-md-6">
											<div className="form-group">
												<label htmlFor="reference" style={{ float: 'left' }} className="col-form-label">Reference:</label>
												<input
													type="text"
													className="form-control"
													id="reference"
													name="reference"
													value={reference}
													onChange={(e) => setReference(e.target.value)}
												/>
											</div>
										</div>
									</div>


								</div>
								<div className="modal-footer">
									<button type="button" className="common-closebtn" data-bs-dismiss="modal" >Close</button>
									<button type="submit" className="float-right-btn common-popup-btn" data-bs-dismiss="modal" >Submit</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>

			{showAllocationModal && (
				<div
					className="modal fade show"
					style={{ display: 'block', background: 'rgba(0,0,0,0.5)'}}
					tabIndex="-1"
					role="dialog"
				>

					<div className="modal-dialog modal-xl modal-dialog-centered" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">Invoice Payment Allocation zxcz</h5>
								<button type="button" className="btn-close" onClick={handleCloseAllocationModal}></button>
							</div>
							<div className="modal-body">
								<InvoicePaymentAllocation
									customer_id={allocationCustomerId}
									fromDate={dates[0] ? format(dates[0], 'MM/dd/yyyy') : ''}
									toDate={dates[1] ? format(dates[1], 'MM/dd/yyyy') : ''}
									onClose={handleCloseAllocationModal}
									onSuccess={() => {
										// Refresh ledger after allocation and close modal
										let startDate = dates[0] ? format(dates[0], 'MM/dd/yyyy') : '';
										let endDate = dates[1] ? format(dates[1], 'MM/dd/yyyy') : '';
										loadCustomerLadger(customerInputValue?.value, startDate, endDate);
										handleCloseAllocationModal();
									}}
									API_URL={API_URL}
									accessToken={accessToken}
								/>
							</div>
						</div>
					</div>
				</div>
			)}

			<Footer />
			<FlashMessage
				message={flashMessage?.message}
				type={flashMessage?.type}
				onClose={handleCloseMessage}
			/>

		</>
	);
}

export default CustomerAccounts;
